import { keyBy } from 'lodash';

const completedScreen = 73;

const artScreens = keyBy(
    [
        {
            id: 45,
            description: 'Have you ever been prescribed ART?',
            defaultNextScreen: null
        },
        {
            id: 46,
            description: 'Type of ART',
            defaultNextScreen: null
        },
        {
            id: 47,
            description: 'Resources - Back on ART',
            defaultNextScreen: completedScreen
        },
        {
            id: 48,
            description: 'Resources - Starting ART',
            defaultNextScreen: completedScreen
        },
        {
            id: 49,
            description: 'Moving along',
            defaultNextScreen: completedScreen
        },
        {
            id: 50,
            description: 'ART commitment level',
            defaultNextScreen: null
        },
        {
            id: 51,
            description: 'Behavior motivators',
            defaultNextScreen: 53
        },
        {
            id: 52,
            description: 'Resources - No ART commitment',
            defaultNextScreen: completedScreen
        },
        {
            id: 53,
            description: 'ART adherence screener',
            defaultNextScreen: null
        },
        {
            id: 54,
            description: 'ART adherence scores - low',
            defaultNextScreen: 58
        },
        {
            id: 55,
            description: 'ART adherence scores - perfect',
            defaultNextScreen: completedScreen
        },
        {
            id: 56,
            description: 'ART adherence scores - high',
            defaultNextScreen: null
        },
        {
            id: 57,
            description: 'ART adherence scores - starting',
            defaultNextScreen: completedScreen
        },
        {
            id: 58,
            description: 'Importance of change - Important Points',
            defaultNextScreen: 59
        },
        {
            id: 59,
            description: 'Importance of change - Gaps',
            defaultNextScreen: 60
        },
        {
            id: 60,
            description: 'Downsides of not taking ART daily',
            defaultNextScreen: 61
        },
        {
            id: 61,
            description: 'Barriers to change',
            defaultNextScreen: 62
        },
        {
            id: 62,
            description: 'Barriers to change - reasons',
            defaultNextScreen: 63
        },
        {
            id: 63,
            description: 'Explore ways to take ART regularly',
            defaultNextScreen: null
        },
        {
            id: 64,
            description: 'Strategies for taking ART daily',
            defaultNextScreen: 65
        },
        {
            id: 65,
            description: 'Change motivators',
            defaultNextScreen: 66
        },
        {
            id: 66,
            description: 'Readiness to change',
            defaultNextScreen: null
        },
        {
            id: 67,
            description: 'Readiness to change - rarely',
            defaultNextScreen: 68
        },
        {
            id: 68,
            description: 'Readiness to change - 3 important points',
            defaultNextScreen: 69
        },
        {
            id: 69,
            description: 'Readiness to change - review strategies',
            defaultNextScreen: 70
        },
        {
            id: 70,
            description: 'Readiness to change - scale',
            defaultNextScreen: 71
        },
        {
            id: 71,
            description: 'Readiness to change - wrap up',
            defaultNextScreen: 72
        },
        {
            id: 72,
            description: 'Prep final review',
            defaultNextScreen: completedScreen
        }
    ],
    'id'
);

const artChoices = keyBy(
    [
        {
            id: 1,
            text: 'Yes, I’m on ART (or just starting ART)',
            selected: false,
            userEntered: false,
            nextScreen: 46
        },
        {
            id: 2,
            text: 'Yes, but I’m no longer on ART',
            selected: false,
            userEntered: false,
            nextScreen: 47
        },
        {
            id: 3,
            text: 'No',
            selected: false,
            userEntered: false,
            nextScreen: 48
        },
        {
            id: 4,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null,
            nextScreen: 48
        }
    ],
    'id'
);

const artTypes = keyBy(
    [
        {
            id: 1,
            text: 'Oral medication (pills)',
            selected: false,
            nextScreen: 50
        },
        {
            id: 2,
            text: 'Injections',
            selected: false,
            nextScreen: 49
        }
    ],
    'id'
);

const artCommitment = keyBy(
    [
        {
            id: 1,
            text: 'I’m 100% committed',
            selected: false,
            nextScreen: 51
        },
        {
            id: 2,
            text: 'I’m somewhat committed',
            selected: false,
            nextScreen: 51
        },
        {
            id: 3,
            text: 'I’m not committed at all',
            selected: false,
            nextScreen: 52
        }
    ],
    'id'
);

const artMotivators = keyBy(
    [
        {
            id: 1,
            text: 'I want to live a longer, healthier life',
            selected: false,
            userEntered: false
        },
        {
            id: 2,
            text: 'I want my HIV treatment to be as effective as possible',
            selected: false,
            userEntered: false
        },
        {
            id: 3,
            text: 'I want to invest in myself',
            selected: false,
            userEntered: false
        },
        {
            id: 4,
            text: 'I want to feel empowered to take charge of my health',
            selected: false,
            userEntered: false
        },
        {
            id: 5,
            text: 'I want to feel responsible for my health',
            selected: false,
            userEntered: false
        },
        {
            id: 6,
            text: 'I want to decrease my risk of transmitting HIV',
            selected: false,
            userEntered: false
        },
        {
            id: 7,
            text: 'I want to decrease my anxiety around my health',
            selected: false,
            userEntered: false
        },
        {
            id: 8,
            text: 'I want to be honest with my partner(s) and friends about taking ART regularly',
            selected: false,
            userEntered: false
        },
        {
            id: 9,
            text: 'I want to be a role model for other trans femme folks living with HIV',
            selected: false,
            userEntered: false
        },
        {
            id: 10,
            text: 'I want to have safer sex with my partner(s) who is HIV negative',
            selected: false,
            userEntered: false
        },
        {
            id: 11,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null
        }
    ],
    'id'
);

const artAdherence = keyBy(
    [
        {
            id: 1,
            text: 'Never',
            selected: false,
            nextScreen: 54
        },
        {
            id: 2,
            text: 'Rarely',
            selected: false,
            nextScreen: 54
        },
        {
            id: 3,
            text: 'Sometimes',
            selected: false,
            nextScreen: 54
        },
        {
            id: 4,
            text: 'Usually',
            selected: false,
            nextScreen: 56
        },
        {
            id: 5,
            text: 'Almost always',
            selected: false,
            nextScreen: 55
        },
        {
            id: 6,
            text: 'Always',
            selected: false,
            nextScreen: 55
        },
        {
            id: 7,
            text: 'I just got prescribed ART and I haven’t started taking it yet',
            selected: false,
            nextScreen: 57
        }
    ],
    'id'
);

const artAdherenceSupport = keyBy(
    [
        {
            id: 1,
            text: 'Yes',
            selected: false,
            nextScreen: 58
        },
        {
            id: 2,
            text: 'No',
            selected: false,
            nextScreen: completedScreen
        }
    ],
    'id'
);

const artAdherenceGaps = keyBy(
    [
        {
            id: 1,
            text: 'Before today, I hadn’t realized this gap existed!',
            selected: false
        },
        {
            id: 2,
            text: 'I don’t think taking ART every day is important for me.',
            selected: false
        },
        {
            id: 3,
            text: 'I don’t think I’m someone who’s good at taking medication on a regular basis.',
            selected: false
        },
        {
            id: 4,
            text: 'I don’t know why there’s a gap between my commitment to my health, my knowledge about ART, and my actual behavior.',
            selected: false
        }
    ],
    'id'
);

const artIrregularDownsides = keyBy(
    [
        {
            id: 1,
            text: 'I feel less empowered over my health',
            selected: false,
            userEntered: false
        },
        {
            id: 2,
            text: 'I get anxious or worried about my health',
            selected: false,
            userEntered: false
        },
        {
            id: 3,
            text: 'I feel judged about not protecting my health the best way I can',
            selected: false,
            userEntered: false
        },
        {
            id: 4,
            text: 'I have to share with my partner(s) that I am not regularly taking ART',
            selected: false,
            userEntered: false
        },
        {
            id: 5,
            text: 'I’m disappointed in myself for missing a dose',
            selected: false,
            userEntered: false
        },
        {
            id: 6,
            text: 'I have more fear about getting sick',
            selected: false,
            userEntered: false
        },
        {
            id: 7,
            text: 'I feel less in control of my health',
            selected: false,
            userEntered: false
        },
        {
            id: 8,
            text: 'I have to CORRECTLY and CONSISTENTLY use condoms to have the best chances of not transmitting HIV',
            selected: false,
            userEntered: false
        },
        {
            id: 9,
            text: 'I worry that having sex with my HIV negative partner(s) is higher risk',
            selected: false,
            userEntered: false
        },
        {
            id: 10,
            text: 'I hesitate to have sex with new people',
            selected: false,
            userEntered: false
        },
        {
            id: 11,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null
        }
    ],
    'id'
);

const artBarriers = keyBy(
    [
        {
            id: 1,
            text: 'I have a busy schedule',
            selected: false,
            userEntered: false
        },
        {
            id: 2,
            text: 'I run out of medication',
            selected: false,
            userEntered: false
        },
        {
            id: 3,
            text: 'I can’t afford ART',
            selected: false,
            userEntered: false
        },
        {
            id: 4,
            text: 'I have concerns that other people will judge me',
            selected: false,
            userEntered: false
        },
        {
            id: 5,
            text: 'I have some side-effects',
            selected: false,
            userEntered: false
        },
        {
            id: 6,
            text: 'I forget to take it',
            selected: false,
            userEntered: false
        },
        {
            id: 7,
            text: 'I don’t like my HIV care provider',
            selected: false,
            userEntered: false
        },
        {
            id: 8,
            text: 'I’ve had bad experiences with doctors or other medical providers',
            selected: false,
            userEntered: false
        },
        {
            id: 9,
            text: 'I don’t feel supported to take ART by others around me',
            selected: false,
            userEntered: false
        },
        {
            id: 10,
            text: 'I’m concerned about ART affecting my hormones or making them less effective',
            selected: false,
            userEntered: false
        },
        {
            id: 11,
            text: 'I don’t think taking ART on a regular basis is important',
            selected: false,
            userEntered: false
        },
        {
            id: 12,
            text: 'I don’t want to take ART on a regular basis',
            selected: false,
            userEntered: false
        },
        {
            id: 13,
            text: 'I don’t want to have a follow-up with my HIV care provider on a regular basis',
            selected: false,
            userEntered: false
        },
        {
            id: 14,
            text: 'I feel embarrassed to take ART',
            selected: false,
            userEntered: false
        },
        {
            id: 15,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null
        }
    ],
    'id'
);

const artRegularSupport = keyBy(
    [
        {
            id: 1,
            text: 'Yes, I would like some ideas on how I can take ART more regularly',
            selected: false,
            nextScreen: 64
        },
        {
            id: 2,
            text: 'No thanks',
            selected: false,
            nextScreen: 65
        }
    ],
    'id'
);

const artRegularStrategies = keyBy(
    [
        {
            id: 1,
            text:
                'I could use a small pill box. A weekly pill box with a section for each day can remind you to take your ART and help prevent taking it twice by mistake.',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 2,
            text: 'I could integrate ART as part of my daily routine',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 3,
            text: 'I could take ART at the same time as my vitamins or other medications',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 4,
            text: 'I could set a smart phone reminder',
            selected: false,
            userEntered: false,
            reminderStrategy: true
        },
        {
            id: 5,
            text: 'I could set up a buddy reminder system with a friend/partner. This way both of us can remind each other to take our ART',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 6,
            text: 'I could carry extra doses',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 7,
            text:
                'I could use a medication reminder app such as the Walgreens app, “Alarm and Pill Reminder”, or “Pill Reminder & Medication Tracker” by MyTherapy.',
            selected: false,
            userEntered: false,
            reminderStrategy: true
        },
        {
            id: 8,
            text:
                'I could make up a reminder system that’s super noticeable to me (e.g., a random sticker on my makeup box or bathroom mirror, a string next to my keys, a note on the refrigerator, etc.)',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 9,
            text: 'I could keep a calendar to write down when refills are due and when I need to schedule a doctor’s appointment',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 10,
            text: 'I could take ART with an activity that I do at the same time every day (e.g., brushing teeth, eating lunch, feeding a pet, etc.)',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 11,
            text: 'I could leave medication in a safe place that is easy to spot. ',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 12,
            text:
                'I could link up with an adherence educator (or other support person) who can help me get access to health care, doctors, prescriptions, etc.',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 13,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null,
            reminderStrategy: false
        }
    ],
    'id'
);

const artMotivatorsRevisited = keyBy(
    [
        {
            id: 1,
            text: 'I want to live a longer, healthier life',
            selected: false,
            userEntered: false
        },
        {
            id: 2,
            text: 'I want my HIV treatment to be as effective as possible',
            selected: false,
            userEntered: false
        },
        {
            id: 3,
            text: 'I want to invest in myself',
            selected: false,
            userEntered: false
        },
        {
            id: 4,
            text: 'I want to feel empowered to take charge of my health',
            selected: false,
            userEntered: false
        },
        {
            id: 5,
            text: 'I want to feel responsible for my health',
            selected: false,
            userEntered: false
        },
        {
            id: 6,
            text: 'I want to decrease my risk of transmitting HIV',
            selected: false,
            userEntered: false
        },
        {
            id: 7,
            text: 'I want to decrease my anxiety around my health',
            selected: false,
            userEntered: false
        },
        {
            id: 8,
            text: 'I want to be honest with my partner(s) and friends about taking ART regularly',
            selected: false,
            userEntered: false
        },
        {
            id: 9,
            text: 'I want to be a role model for other trans femme folks living with HIV',
            selected: false,
            userEntered: false
        },
        {
            id: 10,
            text: 'I want to have safer sex with my partner(s) who is HIV negative',
            selected: false,
            userEntered: false
        },
        {
            id: 11,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null
        }
    ],
    'id'
);

const artAdherenceRevisited = keyBy(
    [
        {
            id: 1,
            text: 'Never',
            selected: false,
            nextScreen: 67
        },
        {
            id: 2,
            text: 'Rarely',
            selected: false,
            nextScreen: 67
        },
        {
            id: 3,
            text: 'Sometimes',
            selected: false,
            nextScreen: 67
        },
        {
            id: 4,
            text: 'Usually',
            selected: false,
            nextScreen: 68
        },
        {
            id: 5,
            text: 'Almost always',
            selected: false,
            nextScreen: 68
        },
        {
            id: 6,
            text: 'Always',
            selected: false,
            nextScreen: 68
        }
    ],
    'id'
);

const artRegularStrategiesRevisited = keyBy(
    [
        {
            id: 1,
            text:
                'I could use a small pill box. A weekly pill box with a section for each day can remind you to take your ART and help prevent taking it twice by mistake.',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 2,
            text: 'I could integrate ART as part of my daily routine',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 3,
            text: 'I could take ART at the same time as my vitamins or other medications',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 4,
            text: 'I could set a smart phone reminder',
            selected: false,
            userEntered: false,
            reminderStrategy: true
        },
        {
            id: 5,
            text: 'I could set up a buddy reminder system with a friend/partner. This way both of us can remind each other to take our ART',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 6,
            text: 'I could carry extra doses',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 7,
            text:
                'I could use a medication reminder app such as the Walgreens app, “Alarm and Pill Reminder”, or “Pill Reminder & Medication Tracker” by MyTherapy.',
            selected: false,
            userEntered: false,
            reminderStrategy: true
        },
        {
            id: 8,
            text:
                'I could make up a reminder system that’s super noticeable to me (e.g., a random sticker on my makeup box or bathroom mirror, a string next to my keys, a note on the refrigerator, etc.)',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 9,
            text: 'I could keep a calendar to write down when refills are due and when I need to schedule a doctor’s appointment',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 10,
            text: 'I could take ART with an activity that I do at the same time every day (e.g., brushing teeth, eating lunch, feeding a pet, etc.)',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 11,
            text: 'I could leave medication in a safe place that is easy to spot. ',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 12,
            text:
                'I could link up with an adherence educator (or other support person) who can help me get access to health care, doctors, prescriptions, etc.',
            selected: false,
            userEntered: false,
            reminderStrategy: false
        },
        {
            id: 13,
            text: 'Something else: (please specify)',
            selected: false,
            userEntered: true,
            response: null,
            reminderStrategy: false
        }
    ],
    'id'
);

const artReminder = keyBy(
    [
        {
            id: 1,
            text: 'Yes, I really did set a reminder',
            selected: false
        },
        {
            id: 2,
            text: 'No, I didn’t but I will now',
            selected: false
        },
        {
            id: 3,
            text: 'No, I have decided that an alarm and a reminder is not the best option for me',
            selected: false
        }
    ],
    'id'
);

export {
    artScreens,
    artChoices,
    artTypes,
    artCommitment,
    artMotivators,
    artAdherence,
    artAdherenceSupport,
    artAdherenceGaps,
    artIrregularDownsides,
    artBarriers,
    artRegularSupport,
    artRegularStrategies,
    artMotivatorsRevisited,
    artAdherenceRevisited,
    artRegularStrategiesRevisited,
    artReminder
};
